import React, { useContext } from 'react';
import { Box, Divider, Stack, Typography, useTheme, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EmailVerifiedComponent from 'components/views/profile/EmailVerifiedSection';
import { AvatarComponent } from 'components/views/profile/AvatarComponent/AvatarComponent';
import { DisplayNameSection } from 'components/views/profile/DisplayNameSection/DisplayNameSection';
import { ChangeEmailSection } from 'components/views/profile/ChangeEmailSection/ChangeEmailSection';
import { UserProfileViewContext } from 'context/userProfile/UserProfileViewContext';
import { StyledDivider } from './UserDataSection.styles';
import { createPrefixedPropsFilteredComponent } from 'helpers/styledHelpers';

const StyledDataStack = styled(Stack)({
  height: '280px'
});

const StyledFlexBox = createPrefixedPropsFilteredComponent<{ $flex: number }>(Box)(({ $flex }) => ({
  flex: $flex,
  display: 'flex',
  flexDirection: 'column'
}));

export const UserDataSection = () => {
    const { t } = useTranslation();
    const { user, isProfileOfLoggedUser } = useContext(UserProfileViewContext);
    const theme = useTheme();

    return !!user
    ? <Stack direction={'row'} width='100%' height='35%'>
        <Box width='50%' padding={theme.spacing(2)}>
            <Typography variant="h6" fontWeight={'500'} >{t('profile.yourData')}</Typography>
            <StyledDataStack direction={'column'}  width='100%' padding={theme.spacing(2)}>
                <StyledFlexBox $flex={1}>
                    <DisplayNameSection user={user} isProfileOfLoggedUser={isProfileOfLoggedUser}/>
                </StyledFlexBox>
                <StyledFlexBox $flex={2} marginTop={theme.spacing(1)}>
                    <ChangeEmailSection email={user.email}/>
                </StyledFlexBox>
                <StyledFlexBox $flex={2} marginTop={theme.spacing(1)}>
                    <EmailVerifiedComponent emailVerified={user.emailConfirmed} />
                </StyledFlexBox>
            </StyledDataStack>
        </Box>
        <StyledDivider orientation="vertical" flexItem />
        <Box width='50%' display={'flex'} fontWeight={'500'} justifyContent={'space-between'} padding={theme.spacing(2)}>
            <Typography variant="h6">{t('profile.avatar')}</Typography>
            <AvatarComponent />
        </Box>   
    </Stack> : null;
}